export const faecher = [
  "Deutsch",
  "Englisch",
  "Mathematik",
  "Geografie",
  "Geschichte",
  "Physik",
  "Chemie",
  "Französisch",
  "Musik",
  "Kunst",
  "Religion",
]
// export const faecher = [ "index0subject", "Deutsch", "Englisch", "Mathematik", "Geografie", "Geschichte", ]
